// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { DocumentData } from "./ContentActionsToolbar.state";
import { Status } from "./ContentActionsToolbar.constants";
import { ToolbarPosition } from "./ContentActionsToolbar.props";

type InitializeToolbar = (breakpointIndex: number, isRSThreeDevice: boolean, documentId: string, staticPosition: ToolbarPosition) => void;
type ContentStatuReady = (status: Status) => void;
type DocumentDataReady = (documentData: DocumentData) => void;
type LikeContent = () => void;
type UnlikeContent = () => void;
type DislikeContent = () => void;
type UndislikeContent = () => void;
type ViewportUpdate = (breakpointIndex: number, isRSThreeDevice: boolean) => void;
type SharingToolbarError = (error: Error) => void;

/**
 * Class containing actions that apply to the ContentActionsToolbar connector
 * @class
 */
export class ContentActionsToolbarActions {
    public static initializeToolbar: ActionMap<InitializeToolbar> = new ActionMap<InitializeToolbar>("InitializeToolbar");
    public static ContentStatuReady: ActionMap<ContentStatuReady> = new ActionMap<ContentStatuReady>("ContentStatuReady");
    public static documentDataReady: ActionMap<DocumentDataReady> = new ActionMap<DocumentDataReady>("DocumentDataReady");
    public static likeContent: ActionMap<LikeContent> = new ActionMap<LikeContent>("LikeContent");
    public static unlikeContent: ActionMap<UnlikeContent> = new ActionMap<UnlikeContent>("UnlikeContent");
    public static dislikeContent: ActionMap<DislikeContent> = new ActionMap<DislikeContent>("DislikeContent");
    public static undislikeContent: ActionMap<UndislikeContent> = new ActionMap<UndislikeContent>("UndislikeContent");
    public static sharingToolbarError: ActionMap<SharingToolbarError> = new ActionMap<SharingToolbarError>("SharingToolbarError");
    public static ViewportUpdate: ActionMap<ViewportUpdate> = new ActionMap<ViewportUpdate>("ViewportUpdate");
}